import React, { useEffect, useState } from "react";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";
import { getCenters } from "../../api/centerAPI";
import { CenterData } from "../../types/api/center";
import { useNotification } from "../../hooks/useNotification";
import CustomSnackbar from "../../components/UI/CustomSnackbar";
import Loader from "../../components/Loader/Loader";

const MainPage = () => {
    const [load, setLoad] = useState(false);
    const [centers, setCenters] = useState<Array<CenterData>>();
    const { setNotification, setOpenSnackbar, notification, openSnackbar } = useNotification();

    const fetchCenters = () => {
        setLoad(true);
        getCenters(
            ({ data }) => {
                setCenters(data);
                setLoad(false);
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoad(false);
            },
        );
    };

    useEffect(() => {
        setLoad(true);
        fetchCenters();
    }, []);

    return (
        <div>
            <YMaps
                query={{
                    ns: "use-load-option",
                    load: "control.ZoomControl,control.FullscreenControl,geoObject.addon.balloon",
                }}>
                <Map
                    style={{
                        padding: "10px",
                        height: "400px",
                        width: "100%",
                    }}
                    defaultState={{
                        center: [55.746463, 49.241091],
                        zoom: 6,
                        controls: ["zoomControl", "fullscreenControl"],
                    }}
                    modules={["control.ZoomControl", "control.FullscreenControl"]}>
                    {/*<Clusterer*/}
                    {/*    options={{*/}
                    {/*        groupByCoordinates: false*/}
                    {/*    }}*/}
                    {/*>*/}
                    {centers?.map(center => {
                        const coordinate = JSON.parse(center.address.coords);
                        return (
                            <Placemark
                                key={center.id}
                                geometry={coordinate}
                                modules={[
                                    //чтобы видеть хинты и балуны подключаем данные модули
                                    "objectManager.addon.objectsBalloon",
                                    "objectManager.addon.objectsHint",
                                ]}
                                properties={{
                                    balloonContentHeader: `${center.name}`,
                                    balloonContent: `<p>Руководитель: ${center.chief_work_position}, ${
                                        center.chief_name
                                    } <br/>
Номер телефона: ${center.phone || "не указан"} </br>
Электронная почта: ${center.email || "не указана"}</p>`,
                                }}
                            />
                        );
                    })}
                    {/*</Clusterer>*/}
                </Map>
            </YMaps>
            <CustomSnackbar openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} notification={notification} />
            <Loader backDrop open={load} />
        </div>
    );
};

export default MainPage;
